<template>
  <LaunchModule :module-data="data" data-luko-tracking="Page-Launch_uid" />
</template>

<script>
import LaunchModule from '~/modules/Launch'
import { formatMetaDatas } from '~/utils/metaData'

export default {
  head() {
    return formatMetaDatas(this.metaDatas, this.$route.path)
  },

  components: {
    LaunchModule,
  },

  async asyncData({ $prismic, store, params, app, error }) {
    try {
      const { data, alternate_languages } = await $prismic.api.getByUID(
        'launch_page',
        params.uid,
        {
          lang: app.i18n.localeProperties.prismicIso,
        }
      )

      store.dispatch('setAlternateLanguages', alternate_languages)

      // Extract page settings from PageSettings slice.
      store.commit(
        'page/UPDATE',
        data.body.find((s) => s.slice_type === 'page_settings')
      )
      data.body = data.body.filter((s) => s.slice_type !== 'page_settings')

      return {
        data,
        metaDatas: data.body1 || [],
      }
    } catch (e) {
      console.error(e)

      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>
